var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm._f("translate")('pageNotFoundTitel')))]),_vm._v(" "),_c('p',{staticClass:"message"},[_vm._v("\n        "+_vm._s(_vm._f("translate")('pageNotFoundMessage'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75eca9f9","hasScoped":false,"buble":{"transforms":{}}}!./src/pages/errors/404/template.html
// module id = 1056
// module chunks = 0